<section id="regestration">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card " style="
      width: 100%;
      max-width: 1300px;
  ">
        <div class="card-content">
          <div class="card-body auth-img">
            <div class=" px-4 py-3">
              <h4 class="card-title mb-2">إنشاء حساب جديد</h4>
              <p>املأ النموذج أدناه لإنشاء حساب جديد.</p>
            </div>
            <mat-tab-group mat-stretch-tabs [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event); getIndex($event)">
              <mat-tab label="البيانات الشخصية">
                <div class="row m-0">
                  <div class="col-lg-12 col-md-12 px-4 py-3">
                    <form [formGroup]="registerForm" class="row">
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <div class="form-group">
                          <label>الاسم بالكامل</label>
                          <input [readonly]="completeProfile" type="text" formControlName="name" class="form-control mb-2" placeholder="ادخل الاسم بالكامل"
                                 [ngClass]="{ 'is-invalid': (rf.name.touched) && (rf.name.dirty)  && rf.name.invalid, 'is-valid': (rf.name.touched) && (rf.name.dirty)  && !rf.name.invalid }"
                                 required>
                          <div *ngIf="(rf.name.touched) && (rf.name.dirty) && (rf.name.invalid || rf.name.errors?.required)" class="help-block mt-1 text-danger"> <i
                               class="ft-alert-circle align-middle"></i> الإسم
                            مطلوب </div>
                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <div class="form-group">
                          <label>البريد الإلكتروني</label>
                          <input [readonly]="completeProfile" type="email" formControlName="email" class="form-control mb-2" placeholder="ادخل البريد الإلكتروني"
                                 [ngClass]="{ 'is-invalid': (rf.email.touched) && (rf.email.dirty) && rf.email.invalid, 'is-valid': (rf.email.touched) && (rf.email.dirty) && !rf.email.invalid }"
                                 required>
                          <div *ngIf="(rf.email.touched) && (rf.email.dirty) && (rf.email.errors?.required)" class="help-block mt-1 text-danger"> <i
                               class="ft-alert-circle align-middle"></i>
                            البريد الإلكتروني مطلوب
                          </div>
                          <div *ngIf="(rf.email.touched) && (rf.email.dirty) &&  rf.email.errors?.email" class="help-block mt-1 text-danger">
                            <i class="ft-alert-circle align-middle"></i>
                            البريد الإلكتروني غير صحيح
                          </div>
                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <label>الفئة</label>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-6">
                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="gender" id="maleRadio" value="1" formControlName="gender" checked>
                                <label class="form-check-label mr-4" for="maleRadio">
                                  ذكر
                                </label>
                              </div>
                            </div>
                            <div class="col-lg-6">
                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="gender" id="femaleRadio" value="2" formControlName="gender">
                                <label class="form-check-label mr-4" for="femaleRadio">
                                  أنثي
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- <div class="form-group">
                          <label>النوع</label>
                          <ng-select [items]="genderList" bindLabel="name" class="mb-3" bindValue="value" placeholder="اختر الجنس" formControlName="gender">
                          </ng-select>
                          <div *ngIf="(rf.gender.touched) && (rf.gender.dirty)  && (rf.gender.errors?.required || rf.gender.invalid)" class="text-danger"
                               style="margin-top: -12px;">
                            <i class="ft-alert-circle align-middle"></i>
                            الحقل مطلوب
                          </div>
                        </div> -->
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <div class="form-group">
                          <label>الرقم القومي</label>
                          <input type="number" class="form-control mb-2" formControlName="nationalId" [maxLength]="14"
                                 [ngClass]="{ 'is-invalid': (rf.nationalId.touched) && (rf.nationalId.dirty)  && rf.nationalId.invalid, 'is-valid': (rf.nationalId.touched) && (rf.nationalId.dirty)  && !rf.nationalId.invalid }"
                                 required placeholder="ادخل الرقم القومى">
                          <div *ngIf="(rf.nationalId.touched) && (rf.nationalId.dirty)  && (rf.nationalId.invalid && rf.nationalId.errors?.required)" class="mt-1 text-danger"> <i
                               class="ft-alert-circle align-middle"></i>
                            الرقم القومي مطلوب
                          </div>

                          <div class="text-danger" *ngIf=" (rf.nationalId.touched) && (rf.nationalId.dirty)  && (rf.nationalId.errors?.pattern)">
                            الرقم القومي لابد أن يكون 14 رقم
                          </div>

                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <div class="form-group">
                          <label>رقم الهاتف</label>
                          <input type="number" class="form-control mb-2" formControlName="phoneNumber"
                                 [ngClass]="{ 'is-invalid': (rf.phoneNumber.touched) && (rf.phoneNumber.dirty) && rf.phoneNumber.invalid, 'is-valid': (rf.phoneNumber.touched) && (rf.phoneNumber.dirty) && !rf.phoneNumber.invalid }"
                                 required placeholder="ادخل رقم الهاتف">
                          <div *ngIf="(rf.phoneNumber.touched) && (rf.phoneNumber.dirty) && (rf.phoneNumber.invalid && rf.phoneNumber.errors?.required)"
                               class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i>
                            رقم الهاتف مطلوب
                          </div>
                          <div class="text-danger" *ngIf=" (rf.phoneNumber.touched) && (rf.phoneNumber.dirty) && (rf.phoneNumber.errors?.pattern)">
                            رقم الهاتف غير صحيح
                          </div>

                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile">
                        <div class="form-group">
                          <label>تاريخ الميلاد</label>
                          <input type="date" class="form-control mb-2" formControlName="birthdate"
                                 [ngClass]="{ 'is-invalid': (rf.birthdate.touched) && (rf.birthdate.dirty) && rf.birthdate.invalid, 'is-valid': (rf.birthdate.touched) && (rf.birthdate.dirty) && !rf.birthdate.invalid }"
                                 required placeholder=" ">
                          <div *ngIf="(rf.birthdate.touched) && (rf.birthdate.dirty) && (rf.birthdate.errors?.required)"
                               class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> الحقل
                            مطلوب </div>
                            <div *ngIf="(rf.birthdate.touched) && (rf.birthdate.dirty) && (rf.birthdate.errors?.invalidDate)"
                               class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i>
                               تاريخ الميلاد غير صحيح
                              </div>

                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile" *ngIf="!completeProfile">
                        <div class="form-group">
                          <label>كلمة السر</label>
                          <div class="input-group">
                            <input id="password" [type]="showPasswordText ? 'text' : 'password'" formControlName="password" class="form-control" [ngClass]="{
                       'is-valid' : (rf.password.touched) && (rf.password.dirty) &&  !rf.password.invalid,
                       'is-invalid' : (rf.password.touched) && (rf.password.dirty) &&  rf.password.invalid
                       }" />
                            <div class="input-group-append cursor-pointer" (click)="showPassword()">
                              <b class="input-group-text"><i class="" [class.ft-eye-off]="showPasswordText" [class.ft-eye]="!showPasswordText"></i></b>
                            </div>
                          </div>
                          <div class="text-danger" *ngIf="(rf.password.touched) && (rf.password.dirty) && (rf.password.errors?.required)">
                            <i class="ft-alert-circle align-middle"></i>
                            كلمة السر مطلوبة
                          </div>
                          <div class="text-danger" *ngIf=" (rf.password.touched) && (rf.password.dirty) && (rf.password.errors?.minlength)">
                            كلمة السر لايمكن أن تكون أقل من 8 حروف
                          </div>
                          <div class="text-danger" *ngIf="(rf.password.touched) && (rf.password.dirty) && (rf.password.errors?.pattern)">
                            كلمة السر لابد أن تحتوي علي حروف كبيرة وصغيرة ورموز
                          </div>
                          <div class="text-danger" *ngIf="(rf.password.touched) && (rf.password.dirty) && (rf.password.errors?.notSame)">
                            كلمة السر غير متطابقة
                          </div>
                        </div>
                      </div>
                      <div [class.col-lg-3]="!completeProfile" [class.col-lg-4]="completeProfile" *ngIf="!completeProfile">
                        <div class="form-group">
                          <label>تأكيد كلمة السر</label>
                          <div class="input-group">
                            <input id="confirmPassword" [type]="showPasswordText ? 'text' : 'password'" formControlName="confirmPassword" class="form-control" [ngClass]="{
                       'is-valid' : (rf.confirmPassword.touched) && (rf.confirmPassword.dirty)  &&  !rf.confirmPassword.invalid,
                       'is-invalid' : (rf.confirmPassword.touched) && (rf.confirmPassword.dirty)  &&  rf.confirmPassword.invalid
                       }" />
                            <div class="input-group-append cursor-pointer" (click)="showPassword()">
                              <b class="input-group-text"><i class="" [class.ft-eye-off]="showPasswordText" [class.ft-eye]="!showPasswordText"></i></b>
                            </div>
                          </div>
                          <div class="text-danger" *ngIf="(rf.confirmPassword.touched) && (rf.confirmPassword.dirty) && (rf.confirmPassword.errors?.required)">
                            <i class="ft-alert-circle align-middle"></i>
                            تأكيد كلمة السر مطلوبة
                          </div>
                          <div class="text-danger" *ngIf="(rf.confirmPassword.touched) && (rf.confirmPassword.dirty) && (rf.confirmPassword.errors?.notSame)">
                            كلمة السر غير متطابقة
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6" *ngIf="!completeProfile">
                        <div class="form-group">
                          <label>العنوان</label>
                          <textarea class="form-control mb-2" formControlName="address"></textarea>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                          <a [routerLink]="['/pages/login']" class="btn bg-light mb-2 mb-sm-0" (click)="auth.logout()">العودة للتسجيل</a>
                          <button [disabled]="registerForm.invalid" class="btn btn-primary"
                                  (click)="onSubmit(false)">حفظ واستمرار</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

              </mat-tab>
              <mat-tab label="البيانات التعليمية" [disabled]="registerForm.invalid">
                <div class="row m-0">
                  <div class="col-lg-12 col-md-12 px-4 py-3">
                    <form [formGroup]="getSchoolForm" class="row">
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>المحافظة</label>
                          <ng-select [items]="governorateList" [disabled]="governorateList.length === 0" bindLabel="name" class="mb-3" bindValue="id" placeholder="اختر المحافظة"
                                     formControlName="govId" [clearable]="false">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>الإدارة التعليمة</label>
                          <ng-select [items]="districtList" bindLabel="name" class="mb-3" bindValue="id" placeholder="اختر الادارة التعليمية" 
                                     formControlName="disId" [clearable]="false">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> المدرسة</label>
                          <ng-select [items]="schoolsList" bindLabel="name" class="mb-3" bindValue="id" placeholder="اختر المدرسة" formControlName="schoolId" [clearable]="false">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-lg-4" *ngIf="stageList.length > 0 ">
                        <div class="form-group">
                          <label>المرحلة الدراسية</label>
                          <ng-select [items]="stageList" bindLabel="name" formControlName="stages" [closeOnSelect]="false" [multiple]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر المرحلة الدراسية">
                          </ng-select>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> الصف الدراسي</label>
                          <ng-select [items]="gradeList" bindLabel="name" formControlName="grades" [closeOnSelect]="false" [multiple]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر  الصف الدراسي">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> المواد</label>
                          <ng-select [items]="subjectList" bindLabel="name" formControlName="subjects" [closeOnSelect]="false" [multiple]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر المادة">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>  الجامعة</label>
                          <ng-select [items]="universities" bindLabel="arabicName" formControlName="university" [closeOnSelect]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر  الدرجة الاكاديمية">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> الكلية </label>
                          <ng-select [items]="collages" bindLabel="arabicName" formControlName="college" [closeOnSelect]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر  الدرجة الاكاديمية">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>  دراسات عليا</label>
                          <ng-select [items]="postgraduates" bindLabel="name" formControlName="postgraduate" [closeOnSelect]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر  الدرجة الاكاديمية">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>  الوظيفة الحالية</label>
                          <ng-select [items]="occupationList" bindLabel="arabicName" formControlName="occupationId" [closeOnSelect]="true" class="mb-3" bindValue="id"
                                     placeholder="اختر العمل الاكاديمى">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> سنوات الخبرة</label>
                          <ng-select [items]="yearsExperinceList" bindLabel="name" formControlName="academicApproach" [closeOnSelect]="true" class="mb-3" bindValue="value"
                                     placeholder="اختر عدد سنوات الخبرة">
                          </ng-select>
                        </div>
                      </div>
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label> المدينة </label>
                          <ng-select [items]="cities" bindLabel="arabicName" formControlName="areaOfInteresetCityId" [closeOnSelect]="true" class="mb-3" bindValue="id"
                                     placeholder="المدينة">
                          </ng-select>
                        </div>
                      </div>


                      <div class="col-lg-12">
                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                          <a class="btn bg-light mb-2 mb-sm-0" (click)="selected.setValue(0)">السابق </a>
                          <button class="btn btn-primary" (click)="onSubmit(false)" [disabled]="getSchoolForm.invalid">حفظ واستمرار</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="المستندات المطلوبة" [disabled]="getSchoolForm.invalid" >
                <div class="row m-0">
                  <div class="col-lg-12 col-md-12 px-4 py-3">
                    <div class="row" *ngIf="attachments.length  > 0">
                      <div class="col-lg-6" *ngFor="let item of attachments; let i = index">
                        <label>{{item.name}}  <b class="text-danger" *ngIf="item.required">*</b></label>
                        <div class=" upload mx-auto	mb-lg-0 mb-4  ">
                          <div [ngClass]="{uploaded: item.url}" class="upload-file d-flex flex-column justify-content-center mx-auto align-items-center position-relative"
                               *ngIf="!item.url">
                            <div class="text-center">
                              <input id="upload" type="file" (change)="uploadFile($event,i,item.maxSize)" class="p-absolute" accept=".png,.jpg,.jpeg,.pdf">
                              <svg id="upload" xmlns="http://www.w3.org/2000/svg" width="39.554" height="42.191" class="icon-upload mb-3" viewBox="0 0 39.554 42.191">
                                <g id="Group_9206" data-name="Group 9206" transform="translate(9.229)">
                                  <g id="Group_9205" data-name="Group 9205">
                                    <path id="Path_7784" data-name="Path 7784"
                                          d="M148.767,11,139.537.451a1.316,1.316,0,0,0-1.983,0L128.325,11a1.318,1.318,0,0,0,.991,2.186h5.274v17.14a1.319,1.319,0,0,0,1.318,1.318h5.274a1.319,1.319,0,0,0,1.318-1.318V13.185h5.274A1.318,1.318,0,0,0,148.767,11Z"
                                          transform="translate(-127.998 0)" fill="#7d8593" />
                                  </g>
                                </g>
                                <g id="Group_9208" data-name="Group 9208" transform="translate(0 29.006)">
                                  <g id="Group_9207" data-name="Group 9207">
                                    <path id="Path_7785" data-name="Path 7785"
                                          d="M50.28,352v7.911H21.274V352H16v10.548a2.636,2.636,0,0,0,2.637,2.637h34.28a2.635,2.635,0,0,0,2.637-2.637V352Z"
                                          transform="translate(-16 -352)" fill="#7d8593" />
                                  </g>
                                </g>
                              </svg>
                              <h5 class="pb-3">قم بسحب الصور او تصفح الصور الحالية على الجهاز الخاص بك</h5>
                            </div>
                          </div>
                          <!-- end upload-file-->
                          <ng-container *ngIf="item.url">
                            <div class="uploaded upload-file border-0" [class.pdf]="item.src.type =='application/pdf'">
                              <div class="show-photo">
                                <div class="icon" (click)="clearFile(i)">
                                  <i class="ft-trash"></i>
                                </div>
                                <!-- end icon-->
                                <img onerror="this.src = 'assets/img/img.png'" [src]="item.url" alt="photo">
                                <div *ngIf="item.src.type =='application/pdf'" style="padding-right:55px;">
                                  <h3>{{item.src.name}}</h3>
                                  <h4>{{(item.src.size / 1024) |number }}kb</h4>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                          <a class="btn bg-light mb-2 mb-sm-0" (click)="selected.setValue(1)">السابق </a>
                          <!-- also disable if any of attachements is null -->
                          <button class="btn btn-primary" [disabled]="registerForm.invalid || getSchoolForm.invalid || attachmentsInvalid" (click)="onSubmit(true)">إنشاء </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
